import gql from 'graphql-tag';

export class AttachmentMutations {
  static updateDocumentAttachmentMutation = gql`
    mutation UpdateDocumentAttachment(
      $id: String!
      $requireView: Boolean
      $accessRecipientList: [String!]
    ) {
      updateDocumentAttachment(
        id: $id
        requireView: $requireView
        accessRecipientList: $accessRecipientList
      ) {
        id
      }
    }
  `;

  static removeDocumentAttachmentMutation = gql`
    mutation RemoveDocumentAttachment($id: String!) {
      removeDocumentAttachment(id: $id)
    }
  `;
}
